import httpClient from '../../services/httpClient';
import axios from 'axios';
import { cartService } from '../cart/cartService';
import { OrderItem, PlaceOrderResponse, GetOrdersResponse, OrderError } from './typres';

export const orderService = {
  // Place order
  placeOrder: async (contact?: string): Promise<PlaceOrderResponse> => {
    try {
      const { data } = await httpClient.post('/api/Orders', contact ? { contact } : null);
      return data as PlaceOrderResponse;
    } catch (error) {
      console.error('Error placing order:', error);
      if (axios.isAxiosError(error)) {
        throw {
          message: error.response?.data?.message || 'Не удалось оформить заказ. Попробуйте ещё раз.',
          code: error.response?.data?.code || 'ORDER_PLACE_ERROR',
          status: error.response?.status,
        } as OrderError;
      }
      if (error instanceof Error) {
        throw { message: error.message, code: 'ORDER_PLACE_ERROR', status: 400 } as OrderError;
      }
      throw { message: 'Failed to place order. Please try again.', code: 'UNKNOWN_ERROR', status: 500 } as OrderError;
    }
  },

  // Get order history
  getOrders: async (): Promise<GetOrdersResponse> => {
    try {
      const bucket = await cartService.get();
      const userId = bucket.userId;

      const { data } = await httpClient.get('/api/Orders', {
        params: { userId },
      });

      const rawOrders: any[] =
        Array.isArray(data) ? data :
        data?.orders?.$values ?? data?.orders ?? data?.$values ?? [];

      const orders = rawOrders.map((o: any) => ({
        id: Number(o?.id ?? o?.orderId ?? 0),
        date: String(o?.date ?? o?.createdAt ?? o?.createdDate ?? new Date().toISOString()),
        total: Number(o?.total ?? o?.totalPrice ?? 0),
        status: String(o?.status ?? 'completed') as 'pending' | 'completed' | 'cancelled',
        items: (() => {
            const raw: any[] =
              o?.orderProducts?.$values ?? o?.orderProducts ??
              o?.items?.$values ?? o?.items ?? [];
            return raw.map((it: any) => ({
              id:       Number(it?.product?.id ?? it?.id ?? it?.productId ?? 0),
              quantity: Number(it?.quantity ?? it?.count ?? 1),
              name:     it?.product?.name ?? it?.name ?? it?.productName ?? undefined,
              picture:  it?.product?.picture ?? it?.picture ?? it?.image ?? undefined,
              price:    it?.unitPrice ?? it?.product?.price ?? it?.price ?? undefined,
            }));
          })(),
      }));

      return { orders, total: orders.length };
      
      
    } catch (error) {
      console.error('Error fetching orders:', error);
      
      if (error instanceof Error) {
        throw {
          message: error.message,
          code: 'ORDERS_FETCH_ERROR',
          status: 500
        } as OrderError;
      }
      
      throw {
        message: 'Failed to load order history. Please try again.',
        code: 'UNKNOWN_ERROR',
        status: 500
      } as OrderError;
    }
  }
};
